import React, { useState, useEffect } from "react";
import "./index.scss";
import { useLocation } from "react-router-dom";
import { use } from "react";
function AnchorPoint({ anchorPointList }) {
  const location = useLocation();
  const scrollToAnchor = (link) => {
    console.log(link, "link");
    const anchorElement = document.getElementById(link);
    if (anchorElement) {
      anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  };
  useEffect(() => {
    if (location.state) {
      const { activePoint } = location.state;
      if (activePoint && activePoint != undefined)
        console.log("activePoint", activePoint);
        scrollToAnchor(anchorPointList[activePoint].link);
    }
  }, [location.state]);
  // useEffect(() => {
  //   console.log(anchorPointList, "anchorPointList");
  // }, [anchorPointList]);

  return (
    <div className="anchorPoint">
      <div className="anchorPoint_">
        <ul className="anchorPoint_con">
          {anchorPointList.map((item, index) => {
            return (
              <li key={index} onClick={() =>{
                scrollToAnchor(item.link);
              }}>
                <a>{item.name}</a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default AnchorPoint;
